export const RQ_GET_SECONDARY_COMPLIANCE_REPORTS_API = {
  url: 'secondarysalesmaster/compliance/<%= yearMonth %>',
  method: 'GET',
  auth: true,
};
